import { render, staticRenderFns } from "./Viewport.vue?vue&type=template&id=051c84b0&"
import script from "./Viewport.vue?vue&type=script&lang=js&"
export * from "./Viewport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports